<div class="mb-4">
  <app-radial-process-card [title]="'Order Status'" [percent]="'40'"></app-radial-process-card>
</div>
<div class="mb-4">
  <app-radial-process-card [title]="'Bake Progress'" [percent]="'74'"></app-radial-process-card>
</div>


